import { useClientAsyncInit, StatsigProvider, StatsigUser } from '@statsig/react-bindings'
import { PropsWithChildren } from 'react'

import { STATSIG_CLIENT_SDK_KEY } from '@src/config/env'

import { getStatsigOptions } from './statsig-provider.utils'
import { StatsigUserAwareProvider } from './statsig-user-aware'

export function StatsigBrowserProvider({ children, statsigUser }: PropsWithChildren<{ statsigUser: StatsigUser }>) {
  const { client } = useClientAsyncInit(STATSIG_CLIENT_SDK_KEY, statsigUser, getStatsigOptions())
  return (
    <StatsigProvider client={client}>
      <StatsigUserAwareProvider>{children}</StatsigUserAwareProvider>
    </StatsigProvider>
  )
}
